import { Component } from '@angular/core';

@Component({
  selector: 'app-i-frame-test',
  imports: [],
  templateUrl: './i-frame-test.component.html',
  styleUrl: './i-frame-test.component.css',
})
export class IFrameTestComponent {}
